import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { filtroEstados } from "../../helper/ordenHelper";
import { fetchSellers, fetchSellersFilter } from '../../actions/sellersActions';
import { DropDownArrow, customStyleFilter } from "../../template/CustomStyle";
import { limpiarFiltros } from '../../actions/generalActios';
import { filtroMedioMes } from '../../utilities/fechasFiltro';
import { toast } from 'react-toastify';
import UploadFileOrdenes from '../General/UploadFileOrdenes';
import { postCargaMasivaComprobantesApi } from '../../api/axios';
import { fileToBase64 } from '../../utilities/formatFile';
import SwitchVisual from '../General/SwitchVisual';
import PropTypes from "prop-types";

const fechaFiltro = filtroMedioMes();

class FiltroOrdenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numeroPagina: 1,
            cantidadPagina: 10,
            //entidadOrdenamiento: 1,
            idSeller: "",
            idOrden: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: "",
            fechaHasta: "",
            idEstado: "",
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            sellers: [],
            skuMarket: "",
            comprobantesZip: null,
            switchInternacional: false,
            tipoOrden: { label: "Sin especificar", value: 0 },
            idTipoOrden: 0
        }
    };

    // Normaliza distintos tipos que pueda enviar el componente SwitchVisual (boolean, evento, objeto)
    normalizeChecked = (val) => {
        if (typeof val === 'boolean') return val;
        if (!val) return false;
        if (typeof val === 'object') {
            if ('target' in val && typeof val.target.checked !== 'undefined') return !!val.target.checked;
            if ('checked' in val) return !!val.checked;
        }
        return !!val;
    };

    componentDidMount() {
        const { filtro } = this.props;
        this.setState({
            fechaDesde: filtro.fechaDesde != undefined ? filtro.fechaDesde : fechaFiltro.desde,
            fechaHasta: filtro.fechaHasta != undefined ? filtro.fechaHasta : fechaFiltro.hasta,
            idSeller: filtro.idSeller,
            cantidadPagina: 10,
            numeroPagina: 1,
            idOrden: filtro.idOrden != undefined ? filtro.idOrden : "",
            documento: filtro.documento,
            nombre: filtro.nombre,
            apellido: filtro.apellido,
            idEstado: filtro.idEstado,
            skuMarket: filtro.skuMarket,
            seller: {
                label: filtro.seller != undefined ? filtro.seller.label : "",
                value: filtro.seller != undefined ? filtro.seller.value : ""
            },
            estado: {
                label: filtro.estado != undefined ? filtro.estado.label : "",
                value: filtro.estado != undefined ? filtro.estado.value : ""
            },
            switchInternacional: filtro.OrdenProductoInternacional !== undefined ? !!filtro.OrdenProductoInternacional : !!filtro.internacional
        });
    }

    componentDidUpdate(prevProps) {
        const { filtro } = this.props;
        if (filtro !== prevProps.filtro) {
            this.setState({
                fechaDesde: filtro.fechaDesde != undefined ? filtro.fechaDesde : fechaFiltro.desde,
                fechaHasta: filtro.fechaHasta != undefined ? filtro.fechaHasta : fechaFiltro.hasta,
                idSeller: filtro.idSeller,
                cantidadPagina: 10,
                numeroPagina: 1,
                idOrden: filtro.idOrden != undefined ? filtro.idOrden : "",
                documento: filtro.documento,
                nombre: filtro.nombre,
                apellido: filtro.apellido,
                idEstado: filtro.idEstado,
                skuMarket: filtro.skuMarket,
                seller: {
                    label: filtro.seller != undefined ? filtro.seller.label : "",
                    value: filtro.seller != undefined ? filtro.seller.value : ""
                },
                estado: {
                    label: filtro.estado != undefined ? filtro.estado.label : "",
                    value: filtro.estado != undefined ? filtro.estado.value : ""
                },
                switchInternacional: filtro.OrdenProductoInternacional !== undefined ? !!filtro.OrdenProductoInternacional : !!filtro.internacional,
                tipoOrden: filtro.tipoOrden != undefined ? filtro.tipoOrden : { label: "Sin especificar", value: 0 },
                idTipoOrden: filtro.idTipoOrden != undefined ? filtro.idTipoOrden : 0
            });
        }
    }

    myChangeHandler = (e) => {
        const { name } = e.target;
        let { value } = e.target;

        // Actualizo el campo modificado primero
        this.setState({ [name]: value }, () => {
            const trimmed = (value || "").toString().trim();

            // Si el usuario está escribiendo un ID de orden -> limpiar otros filtros (y fechas)
            if (name === "idOrden" && trimmed !== "") {
                this.setState({
                    documento: "",
                    nombre: "",
                    apellido: "",
                    skuMarket: "",
                    idEstado: "",
                    estado: { label: "", value: "" },
                    seller: { label: "", value: "" },
                    // usar cadena vacía en inputs controlados
                    fechaDesde: "",
                    fechaHasta: "",
                    tipoOrden: { label: "Sin especificar", value: 0 },
                    idTipoOrden: 0
                });
                return;
            }

            // Si el usuario escribe en cualquier otro campo -> limpiar idOrden
            if (name !== "idOrden" && trimmed !== "") {
                this.setState({ idOrden: "" });
            }
        });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        this.props.limpiarFiltros({
            publicaciones: true,
            ordenes: false,
            sellers: true,
        });

        const isSearchById = this.state.idOrden != null && this.state.idOrden.toString().trim() !== "";

        let params;
        if (isSearchById) {
            // Si se busca por ID de orden, enviar los demás filtros como null
            params = {
                numeroPagina: this.state.numeroPagina,
                cantidadPagina: this.state.cantidadPagina,
                idSeller: null,
                idOrden: this.state.idOrden,
                documento: null,
                nombre: null,
                apellido: null,
                fechaDesde: "",
                fechaHasta: "",
                estado: { label: "", value: "" },
                idEstado: null,
                skuMarket: null,
                seller: { label: "", value: "" },
                OrdenProductoInternacional: !!this.state.switchInternacional,
                tipoOrden: { label: "Sin especificar", value: 0 },
                idTipoOrden: 0,
                TipoOrden: 0
            };

        } else {
            params = {
                numeroPagina: this.state.numeroPagina,
                cantidadPagina: this.state.cantidadPagina,
                idSeller: this.state.idSeller,
                idOrden: this.state.idOrden !== undefined ? this.state.idOrden : "",
                documento: this.state.documento,
                nombre: this.state.nombre,
                apellido: this.state.apellido,
                fechaDesde: this.state.fechaDesde,
                fechaHasta: this.state.fechaHasta,
                idEstado: this.state.idEstado,
                skuMarket: this.state.skuMarket,
                seller: this.state.seller,
                OrdenProductoInternacional: !!this.state.switchInternacional,
                tipoOrden: this.state.tipoOrden,
                idTipoOrden: this.state.idTipoOrden,
                TipoOrden: this.state.idTipoOrden
            };
        }

        this.props.updateRequest(params);
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
        if (config.name === "estado") {
            this.setState({ idEstado: options.value });
        }
        if (config.name === "seller") {
            this.setState({ idSeller: options.value });
        }
        if (config.name === "tipoOrden") {
            this.setState({ idTipoOrden: options.value });
        }

        // Si el usuario selecciona cualquier filtro distinto a idOrden -> limpiar idOrden
        if (config.name !== "idOrden") {
            this.setState({ idOrden: "" });
        }
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        // Solo buscar cuando el usuario escribe, no cuando selecciona
        if (action.action === 'input-change') {
            this.props.fetchSellersFilter({
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            });
        }
    }

    verTodos = () => {
        const { isCategory, isAdminMod } = this.props.userType;

        this.setState(prevState => ({
            idSeller: isCategory || isAdminMod ? "" : prevState.idSeller,
            estado: { label: "", value: "" },
            seller: { label: "", value: "" },
            idOrden: "",
            documento: "",
            nombre: "",
            apellido: "",
            idEstado: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            switchInternacional: false,
            tipoOrden: { label: "Sin especificar", value: 0 },
            idTipoOrden: 0
        }));

        let params = {
            idSeller: isCategory || isAdminMod ? "" : this.state.idSeller,
            idOrden: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            idEstado: "",
            cantidadPagina: 10,
            numeroPagina: 1,
            TipoOrden: 0
        }


        if (this.props.onClearCantidad) {
            this.props.onClearCantidad();
        }

        if (window.location.pathname === "/Ordenes") {
            this.props.updateRequest(params);
        }
    }

    mapSellers = () => {
        // SIEMPRE cargar sellers cuando se abre el dropdown
        // Esto limpia cualquier filtro previo del dashboard u otras vistas
        this.props.fetchSellersFilter({
            Descripcion: "",
            Page: 1,
            PageSize: 100
        });
    }

    updateFile = async (file) => {
        if (!file) {
            return;
        }

        const base64 = await fileToBase64(file);
        this.setState({ comprobantesZip: base64 });

        let request = {
            IdSeller: this.props.idSeller,
            Filename: file.name ?? "",
            Filecontent: base64
        };

        postCargaMasivaComprobantesApi(request)
            .then((response) => {
                const hasErrors = response.data?.HasErrors;
                const totalOk = response.data?.ProcesadosOk;
                const totalError = response.data?.ProcesadosConError;

                if (hasErrors) {
                    toast.warning(`Carga completada: ${totalOk} ok, ${totalError} con error`);
                    if (Array.isArray(response.data?.Errors)) {
                        response.data.Errors.forEach(err => {
                            const mensaje = err.IdOrden
                                ? `Orden ${err.IdOrden}: ${err.ErrorMesage}`
                                : err.ErrorMesage;
                            toast.error(mensaje);
                        });
                    }
                } else {
                    toast.success(`${totalOk} archivo(s) cargado(s) exitosamente`);
                }
            })
            .catch((error) => {
                const errores = error?.response?.data?.errores;

                if (Array.isArray(errores)) {
                    errores.forEach(err => {
                        // Si err es un objeto con idOrden y errorMesage
                        if (typeof err === 'object' && err.errorMesage && err.idOrden) {
                            toast.error(`Orden ${err.idOrden}: ${err.errorMesage}`);
                        } else if (typeof err === 'object' && err.errorMesage) {
                            // Solo tiene errorMesage
                            toast.error(err.errorMesage);
                        } else if (typeof err === 'string') {
                            // Si err es un string simple
                            toast.error(err);
                        } else {
                            toast.error(JSON.stringify(err));
                        }
                    });
                } else if (error?.response?.status === 400) {
                    toast.error("Solicitud inválida. Verifica los datos del archivo.");
                } else {
                    toast.error("Error al subir el archivo");
                }

            });
    }

    render() {
        const { loadingExport, userType } = this.props;

        let listaSeller = [];
        if (this.props.sellers != undefined) {
            this.props.sellers.map((item) => {
                listaSeller.push({ label: item.label, value: item.value.toString() })
            })
        }
        // Agregar opción "Todos" si no está ya en la lista
        if (listaSeller.length > 0 && listaSeller[0]?.value !== "") {
            listaSeller.unshift({ value: "", label: "Todos" });
        }

        const isSearchById = this.state.idOrden != null && this.state.idOrden.toString().trim() !== "";
        const classCol = 'col-lg-2';
        const isFiltering = !!loadingExport;

        return (
            <form
                className="card card-body filter-card"
                onSubmit={this.onSubmit}
                onReset={this.verTodos}
                style={{ position: 'relative' }}
            >
                <div className="row form-material">

                    {this.props.allowSearchBySeller && (
                        <div className={classCol}>
                            <label htmlFor="sellersFiltroOrdenes" className="label-oscura">Sellers</label>
                            <Select
                                id="sellersFiltroOrdenes"
                                name="seller"
                                value={this.state.seller}
                                options={listaSeller}
                                onChange={this.selectSearchHandler}
                                onMenuOpen={this.mapSellers}
                                onInputChange={this.onSelectSearchInputSellers}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyleFilter}
                                isDisabled={isSearchById}
                            />
                        </div>
                    )}

                    <div className={classCol}>
                        <label htmlFor="estadosFiltroOrdenes" className="label-oscura">Estados</label>
                        <Select
                            id="estadosFiltroOrdenes"
                            name="estado"
                            value={this.state.estado}
                            options={filtroEstados}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            isDisabled={isSearchById}
                        />
                    </div>

                    <div className={classCol}>
                        <label htmlFor="tipoOrdenFiltroOrdenes" className="label-oscura">Tipo Orden</label>
                        <Select
                            id="tipoOrdenFiltroOrdenes"
                            name="tipoOrden"
                            value={this.state.tipoOrden}
                            options={[{ label: "Sin especificar", value: 0 }, { label: "Venta telefónica", value: 1 }]}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            isDisabled={isSearchById}
                        />
                    </div>

                    <div className={classCol}>
                        <label htmlFor="ordenFiltroOrdenes" className="label-oscura">Orden</label>
                        <input
                            id="ordenFiltroOrdenes"
                            type="number"
                            name="idOrden"
                            className="form-control"
                            value={this.state.idOrden == null ? "" : this.state.idOrden}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className={classCol}>
                        <label htmlFor="dniFiltroOrdenes" className="label-oscura">DNI</label>
                        <input
                            id="dniFiltroOrdenes"
                            type="number"
                            name="documento"
                            className="form-control"
                            value={this.state.documento == null ? "" : this.state.documento}
                            onChange={this.myChangeHandler}
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classCol}>
                        <label htmlFor="apellidoFiltroOrdenes" className="label-oscura">Apellido</label>
                        <input
                            id="apellidoFiltroOrdenes"
                            type="text"
                            name="apellido"
                            className="form-control"
                            value={this.state.apellido == null ? "" : this.state.apellido}
                            onChange={this.myChangeHandler}
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classCol}>
                        <label htmlFor="skuMarketFiltroOrdenes" className="label-oscura">SkuMarket</label>
                        <input
                            id="skuMarketFiltroOrdenes"
                            type="text"
                            name="skuMarket"
                            className="form-control"
                            value={this.state.skuMarket == null ? "" : this.state.skuMarket}
                            onChange={this.myChangeHandler}
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classCol}>
                        <label htmlFor="fechaDesdeFiltroOrdenes" className="label-oscura">Fecha desde</label>
                        <input
                            id="fechaDesdeFiltroOrdenes"
                            type="date"
                            name="fechaDesde"
                            className="form-control"
                            value={this.state.fechaDesde}
                            onChange={this.myChangeHandler}
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classCol}>
                        <label htmlFor="fechaHastaFiltroOrdenes" className="label-oscura">Fecha hasta</label>
                        <input
                            id="fechaHastaFiltroOrdenes"
                            type="date"
                            name="fechaHasta"
                            className="form-control"
                            value={this.state.fechaHasta}
                            onChange={this.myChangeHandler}
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classCol}>
                        <div className="label-oscura d-block">&nbsp;</div>
                        <SwitchVisual
                            label="Internacional"
                            labelPosition="left"
                            checked={this.state.switchInternacional}
                            onChange={checked => this.setState({ switchInternacional: this.normalizeChecked(checked) })}
                            disabled={isFiltering}
                            labelStyle={{ fontWeight: 600, color: '#525f7f', fontSize: '0.9rem', marginBottom: '0.4rem' }}
                            labelClassName="label-oscura"
                        />
                        <small style={{ color: this.state.switchInternacional ? 'green' : 'red', marginTop: '2px', fontWeight: 'bold', fontSize: '10px' }}>
                            {this.state.switchInternacional ? 'Activo' : 'Inactivo'}
                        </small>
                    </div>

                </div>

                <div className="row p-10">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                        <button
                            className="btn d-inline btn-sm btn-grey m-r-10"
                            //disabled={this.props.loadingOrdenes}
                            disabled={loadingExport}
                            type='submit'
                        >
                            Buscar
                        </button>
                        <button
                            className="btn btn-sm btn-grey d-inline"
                            type='reset'
                        >
                            Limpiar
                        </button>
                    </div>
                </div>

                {(userType.isSellerAdmin || userType.isSeller) && (
                    <div className="row mt-3">
                        <div className="col-12 d-flex justify-content-center justify-content-lg-end">
                            <div
                                style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "8px",
                                    padding: "8px 10px",
                                    backgroundColor: "#f9f9f9",
                                    width: "100%",
                                    maxWidth: "220px"
                                }}
                            >
                                <label
                                    className="font-weight-bold"
                                    style={{
                                        fontSize: "11px",
                                        marginBottom: "6px",
                                        display: "block",
                                        lineHeight: 1.2
                                    }}
                                >
                                    Carga masiva de comprobantes
                                </label>

                                <UploadFileOrdenes
                                    inputId="cargaMasivaComprobantesFiltroOrdenes"
                                    className="form-control"
                                    style={{
                                        width: "100%"
                                    }}
                                    acceptType=".zip"
                                    onFileLoaded={this.updateFile}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </form>
        );
    }
}
FiltroOrdenes.propTypes = {
    // Redux props
    filtro: PropTypes.shape({
        fechaDesde: PropTypes.string,
        fechaHasta: PropTypes.string,
        idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        documento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nombre: PropTypes.string,
        apellido: PropTypes.string,
        idEstado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        skuMarket: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        seller: PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        estado: PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        internacional: PropTypes.bool,
        ordenProductoInternacional: PropTypes.bool,
        tipoOrden: PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        idTipoOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    userType: PropTypes.shape({
        isCategory: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isSeller: PropTypes.bool,
        isSellerAdmin: PropTypes.bool,
    }),
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loadingExport: PropTypes.bool,
    sellers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    allowSearchBySeller: PropTypes.bool,
    // Actions props
    updateRequest: PropTypes.func,
    limpiarFiltros: PropTypes.func,
    fetchSellersFilter: PropTypes.func,
    onClearCantidad: PropTypes.func,
}


const mapStateToProps = state => ({
    loadingOrdenes: state.ordenes.loadingOrdenes,
    sellers: state.sellers.filteredSellers,
    userType: state.general.userType,
    idSeller: state.general.idSeller,
});

export default connect(mapStateToProps, {
    fetchSellers,
    fetchSellersFilter,
    limpiarFiltros
})(FiltroOrdenes);
